import React from 'react';
import TitleBar from 'src/components/titleBar/TitleBar';
import CampFire from '../components/campfire/CampFire';

export default function HomePage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100 p-4">
      <TitleBar />
      <h1 className="text-4xl font-bold text-gray-800 mb-8 text-center">We are the <span className="pulse-text-5">Ashbury Amigos</span></h1>
      <h1 className="write-in text-4xl font-bold text-gray-800 text-center">Welcome to our home</h1>
      <CampFire />
    </div>
  );
}
